import { DrawerOverlay, DrawerBody, useDisclosure, Drawer, DrawerContent, Box } from '@chakra-ui/react'
import { useAgendamentoRetorno } from './hooks/useAgendamentoRetorno'
import { Header } from './components/Header'
import { TableAgendamentos } from './components/TableAgendamentos'
import { FormAgendamento } from './components/FormAgendamento'

export function AgendamentoRetornoCliente({ numeroNota, infoProposta, onSend = null, children, pedidoBloqueado }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    getAgendamentos: { data },
    agendarRetorno,
  } = useAgendamentoRetorno({
    numeroNota,
    codigoParceiro: infoProposta?.cliente?.codigo_parceiro,
    codigoContato: infoProposta?.codigo_contato,
    numeroPedido: infoProposta?.numero_pedido,
  })

  return (
    <>
      <Box onClick={onOpen}>{children}</Box>

      <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <Header />
          <DrawerBody h="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <FormAgendamento
              numeroNota={numeroNota}
              infoProposta={infoProposta}
              onSend={onSend}
              agendarRetorno={agendarRetorno}
              onSubmitSuccess={onClose}
              pedidoBloqueado={pedidoBloqueado}
            />
          </DrawerBody>
          <TableAgendamentos data={data} onClose={onClose} />
        </DrawerContent>
      </Drawer>
    </>
  )
}
